/** Store-scoped keys: switching stores never shares cache. */
export const workflowKeys = {
  all: (storeId: string) => ['stores', storeId, 'workflow-templates'] as const,
  list: (storeId: string) => [...workflowKeys.all(storeId), 'list'] as const,
  detail: (storeId: string, id: string) => [...workflowKeys.all(storeId), 'detail', id] as const,
  qcAll: (storeId: string) => ['stores', storeId, 'qc-templates'] as const,
  qcList: (storeId: string) => [...workflowKeys.qcAll(storeId), 'list'] as const,
  qcDetail: (storeId: string, id: string) =>
    [...workflowKeys.qcAll(storeId), 'detail', id] as const,
};
